// extracted by mini-css-extract-plugin
export default {"priorityWrapper":"WisePriorityComponent_priorityWrapper__jGSxI","icon":"WisePriorityComponent_icon__fpllO"};